<template>
  <div id="app">
    <transition name="fade">
      <Loader :show="Loader" />
    </transition>
    <!-- SNOW EFFECT -->
    <Snow 
    :amount="isMobile ? effect.amount/6 : effect.amount"
    :size="effect.size"
    :speed="effect.speed"
    :wind="effect.wind"
    :opacity="effect.opacity"
    :swing="effect.swing"
    @changeOptions="changeEffect" />
    
    <section class="hero is-dark is-fullheight" :style="layoutStyles">

    <!-- Vote Notification -->
    <transition name="fadeRight" >
    <vote-notif v-if="show.voteNotif" @vote="show.vote = true" @close-notification="show.voteNotif = false" />
    </transition>

      <!-- Hero head: will stick at the top -->
      <div class="hero-head">
        <Navbar 
        @login="show.login=true"
        @register="show.register=true"
        @logout="logOut()"
        :currentPage="page.current.name"
        :loggedIn="loggedIn"
        :user="currentUser" />
      </div>

      <!-- TABS on Mobile -->
      <div class="hero-foot is-hidden-desktop">
        <Tabs :currentPage="page.current.name" />
      </div>
      <!-- /TABS on Mobile -->

      <!-- Hero content: will be in the middle -->
      <div class="hero-body" @click="$store.commit('ExpandBurger',false)">
        <div class="container has-text-centered">
          <Header 
          :title="page.title"
          :breadcrumb="page.breadcrumb"/>
          <div class="box mc dark-border">
            <transition name="fade" mode="out-in">
              <router-view 
                :key="$route.fullPath"
                :loggedIn="loggedIn"
                :user="currentUser"
                :api="api" />
            </transition>
          </div>
          <Footer />
        </div>
      </div>

      <!-- Hero footer: will stick at the bottom -->
      <div class="hero-foot is-hidden-touch">
        <Tabs :currentPage="page.current.name" />
      </div>
    </section>

    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <transition name="fade">
      <Login v-if="show.login"
      :show="show.login"
      @close-modal="show.login=false" />
    </transition>
    <transition name="fade">
      <Register v-if="show.register"
      :show="show.register"
      @close-modal="show.register=false" />
    </transition>
    <transition name="fade">
      <vote-modal v-show="show.vote"
      :show="show.vote"
      @close-modal="show.vote=false" />
    </transition>
    <transition name="fade">
      <online-modal v-show="online"
      :show="online"
      @close-modal="$store.commit('closeOnlineModal')" />
    </transition>

  </div>
</template>

<script>
import Footer from '@/components/footer/default'
import Navbar from '@/components/navbar/default'
import Tabs from '@/components/tabs/heroFootTabs'
import Login from '@/views/Login'
import Register from '@/views/Register'
import Snow from '@/components/Snowf'
import Loader from '@/components/loader/default'
import Header from '@/components/headers/pageHeaders'

import Swal from 'sweetalert2'
// import UserService from '@/services/user.service.js';

import VoteNotif from '@/components/notification/vote.vue'
import VoteModal from '@/components/modals/vote.vue'
import OnlineModal from '@/components/modals/online.vue'
export default {
  name:'MuCrisisWebsite',
  components: {
    Footer,
    Navbar,
    Tabs,
    Login,
    Register,
    Snow,
    Loader,
    Header,
    VoteNotif,
    VoteModal,
    OnlineModal
  },
  timers: {
      notifications: { time: 2500, autostart: true, repeat:false }
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    layoutStyles() {
      return {
        'background': `url(${this.$store.state.backgroundImage}) no-repeat`,
        'background-position': 'center',
        'background-size':'cover'
      }
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    Loader() {
      return this.$store.getters.GetLoader
    },
    page() {
      return this.$store.getters.GetPage
    },
    api() {
      return this.$store.getters.GetApiPath
    },
    cookies() {
      return this.$store.getters.CheckCookies
    },
    isMobile() {
      return this.$store.getters.GetMobileBrowser
    },
    endpoint() {
      return this.$store.getters.GetEndpoints.general
    },
    online() {
      return this.$store.getters.GetPlayersOnlineModal
    }
  },
  data:()=>({
    show: {
      login:false,
      register:false,
      vote:false,
      voteNotif:false
    },
    effect: {
      amount:600,
      size: 3,
      speed:1,
      wind:0,
      opacity:0.8,
      swing:1
    }
  }),
  created() {
    // if(this.loggedIn) {
    //   UserService.verifyIsAuth()
    //     .catch(()=> { 
    //       this.$store.dispatch('auth/logout'); 
    //       if (this.page.current.name == 'dashboard' && this.page.current.number == 6) this.login=true 
    //     })
    // }
    const generalConfigData = this.$store.getters.GetJson('general')
    this.$store.dispatch('generalConfig', generalConfigData)
    this.showCookies()
  },
  mounted() {
    this.$store.commit('setLoader', false)
  },
  methods: {
    notifications() {
      this.show.voteNotif = true
    },
    async logOut() {
      await this.$store.dispatch('auth/logout');

      let timerInterval
      Swal.fire({
        title: 'Te desconectaras en...',
        html: '<b></b>',
        timer: 2000,
        timerProgressBar: true,
        onBeforeOpen: () => {
          Swal.showLoading()
          timerInterval = setInterval(() => {
            const content = Swal.getContent()
            if (content) {
              const b = content.querySelector('b')
              if (b) {
                b.textContent = Swal.getTimerLeft()
              }
            }
          }, 100)
        },
        onClose: () => {
          clearInterval(timerInterval)
        }
      }).then((result) => {
        /* Read more about handling dismissals below */
        if (result.dismiss === Swal.DismissReason.timer) {
          this.$router.push({ name: 'home'})
        }
      })
    },
    showCookies() {
      if(!this.cookies) {
        this.$toasted.show("Utilizamos cookies propias y de terceros para mejorar la experiencia del usuario a través de su navegación. Si continúas navegando aceptas su uso.", { 
          theme: "toasted-primary", 
          position: "bottom-center", 
          duration : null,
          fullWidth:true,
          action : [
              {
                  text : 'Ver Política de Privacidad',
                  onClick : (toastObject) => {
                      this.closeCookies()
                      this.$router.push('/politica-de-privacidad')
                      toastObject.goAway(0)
                  },
              },
              {
                  text : 'Entendido',
                  onClick : (e, toastObject) => {
                      this.closeCookies()
                      toastObject.goAway(0);
                  }
              },
          ]
        });
      }
    },
    closeCookies(){
      this.$store.dispatch('makeCookies')
    },
    changeEffect(data) {
      this.effect = data
    }
  }
}
</script>

<style scoped>
  .box.mc {
    background: hsla(0, 0%, 21%, .5);
    overflow-y: auto;
    overflow-x: hidden;
    border-radius: 14px;
  }
  @media screen and (max-width: 980px) {
    .box.mc {
      border-radius: 0 !important;
    }
    /* .box {
      height: calc(100vh - 315px) !important;
    } */
    .hero-body {
      padding: 0 0 !important;
    }
  }
  @media screen and (min-width: 1023px) {
    .box.mc {
      height: calc(100vh - 325px) !important;
    }
  }
</style>
